import axios from 'axios'
import qs from 'qs'
import Vue from 'vue';
//2.新创建一个vue实例
let v = new Vue();
import router from './router'
import { getToken } from '@/utils/auth'
import { removeToken } from "@/components/auth"; // get token from cookie
const config2 = require('@/components/Global');
axios.defaults.timeout = 300000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; //配置请求头
let protocol = window.location.protocol; //协议
let host = window.location.host; //主机
let reg = /^localhost+/;
// if(reg.test(host)) {
//    //若本地项目调试使用
//   // axios.defaults.baseURL = 'http://localhost/index/';   //配置接口地址
//    axios.defaults.baseURL = '';//'//web.huasivip.com/api/public/index/';   //配置接口地址

// } else {
//     //动态请求地址             协议               主机
//     axios.defaults.baseURL = '';   //配置接口地址
// }


//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    let url = config.url;
    // console.log((url.indexOf("zhushou.huasivip.com/admin/api/public/index/admin/getlistdl")>-1))
    let token = (url.indexOf("zhushou.huasivip.com/admin/api/public/index/admin/getlistdl") <= 0) ? (config2.default.token || getToken()) : config2.default.dailiinfo.token;
    //在发送请求之前做某件事
    let s = window.my ? "cs" : "web";



    config.headers.common['token'] = token; //config2.default.token||getToken();
    config.headers.common['from'] = s || "未知";
    if (config.method === 'post') {
        config.data = qs.stringify(config.data);
    }

    return config;
}, (error) => {
    console.log('错误的传参')
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    if (res.data == "401error") {
        config2.default.token = "";
        v.$notify({
            title: "注意",
            message: "由于您的权限信息发生了变化,请重新登录！",
            type: "warning"
        });

        logout();
        // {   removeToken('');
        //     router.replace({
        //         path: '/login',
        //         // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
        //     })

    }
    if (res.data == "403error") {
        config2.default.token = "";
        v.$notify({
            title: "注意",
            message: "由于您的权限信息发生了变化,请重新登录！",
            type: "warning"
        });

        daili();


    }
    //对响应数据做些事
    if (!res.data.success) {
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    console.log(error);
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
//返回一个Promise(发送post请求)
export function fetchPut(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
async function logout() { //退出
    removeToken('')
        //   await this.$store.dispatch('user/logout')

    router.replace({
        path: '/login',
        // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
    })
}
async function daili() { //退出
    removeToken('')
        //   await this.$store.dispatch('user/logout')

    router.replace({
        path: '/dl',
        // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
    })
}
async function fetchPostAwait(url, params) {

    axios.post(url, params)
        .then(response => {
            return (response);
        }, err => {
            return (err);
        })
        .catch((error) => {
            return (error)
        })

}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: param })
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// export function test() {
//    return fetchPost("setting/rolelistByname", { name: 'admin' });
// }
export default {
    fetchPost,
    fetchGet,
    fetchPut,
    fetchPostAwait,
    // test
}


// WEBPACK FOOTER //
// ./src/https.js